import { captureException } from '@/plugins/debugging';
import store from '@/store';

/**
 * @param numberStr { String }
 * @return { String }
 */
export function removeEmptyDecimals(numberStr) {
  if (numberStr.endsWith('.00')) {
    return numberStr.substring(0, numberStr.length - 3);
  }

  return numberStr;
}

/**
 * @param stringOrNumber { String | Number }
 * @return { String }
 */

export function formatDecimals(stringOrNumber) {
  const DECIMAL_SEPARATOR = '.';
  const numberStr = removeEmptyDecimals(`${stringOrNumber}`);
  if (numberStr.includes(DECIMAL_SEPARATOR)) {
    const res = numberStr.split(DECIMAL_SEPARATOR);
    const wholeNumber = res[0];
    let decimals = res[1];

    // make sure each price has two decimals
    if (decimals.length === 1) {
      decimals = `${decimals}0`;
    }

    // Prices can't have more than 99 cents, just ignore everything after the second decimal place
    decimals = decimals.substring(0, 2);

    return `${wholeNumber}${DECIMAL_SEPARATOR}${decimals}`;
  }

  return numberStr;
}


/**
 * @param stringOrNumber { String | Number }
 * @return { Number }
 */
export function toNumber(stringOrNumber = '') {
  if (typeof stringOrNumber === 'number') {
    return stringOrNumber;
  }

  if (!stringOrNumber) {
    return null;
  }

  const float = Number.parseFloat(
    stringOrNumber
      .replace(',', '.')
      .replace(/[^\d.-]/g, ''),
  );

  if (Number.isNaN(float)) {
    return null;
  }

  return float;
}

/**
 * @param stringOrNumber { String | Number }
 * @param currencySymbol { String }
 * @return { String }
 */
export function toPrice(stringOrNumber, currencySymbol) {
  // todo use formatCurrency from dealCalculatorView here?
  if (!currencySymbol) {
    captureException(new Error('toPrice was called without a currencySymbol'));
  }

  if (stringOrNumber === undefined || stringOrNumber === null || stringOrNumber === '') {
    return null;
  }

  const string = formatDecimals(toNumber(stringOrNumber));
  return `${currencySymbol}${string}`;
}
